// Capture-phase: block navigation from any swatch link, regardless of
// whether the custom element has finished initializing.
document.addEventListener(
  "click",
  function (e) {
    const link = e.target.closest("color-swatch [data-value]");
    if (!link) return;
    e.preventDefault();
    updateProductCardFromSwatch(link);
    // Dispatch a custom event so the color-swatch element can react
    const swatchEl = link.closest("color-swatch");
    if (swatchEl) {
      swatchEl.dispatchEvent(
        new CustomEvent("swatch-select", {
          bubbles: false,
          detail: { target: link },
        })
      );
    }
  },
  true // capture phase
);

document.addEventListener(
  "click",
  function (e) {
    const btn = e.target.closest(".product-card__quick-size-btn");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    populateQuickSizeVariant(btn);
    quickSizeAddToCart(btn);
    const card = btn.closest(".product-card");
    if (card) card.classList.remove("quick-sizes-open");
  },
  true
);

document.addEventListener(
  "click",
  function (e) {
    const trigger = e.target.closest(".product-card__quick-add-trigger");
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    const card = trigger.closest(".product-card");
    if (!card) return;
    const isOpen = card.classList.contains("quick-sizes-open");
    document.querySelectorAll(".product-card.quick-sizes-open").forEach((c) => {
      if (c !== card) c.classList.remove("quick-sizes-open");
    });
    card.classList.toggle("quick-sizes-open", !isOpen);
  },
  true
);

document.addEventListener("click", function (e) {
  if (e.target.closest(".product-card.quick-sizes-open")) return;
  document.querySelectorAll(".product-card.quick-sizes-open").forEach((c) => {
    c.classList.remove("quick-sizes-open");
  });
});

function getVariantDataForSwatch(swatchNode, variantDataOverride) {
  if (variantDataOverride) return variantDataOverride;

  const swatchEl = swatchNode && swatchNode.closest("color-swatch");
  if (!swatchEl || !swatchEl.nextElementSibling) return [];

  if (!swatchEl.variantData) {
    swatchEl.variantData = JSON.parse(swatchEl.nextElementSibling.textContent);
  }

  return swatchEl.variantData;
}

function getSwatchVariant(swatchNode, variantDataOverride) {
  const { optionPosition, value } = swatchNode.dataset;
  if (!optionPosition || !value) return null;

  return getVariantDataForSwatch(swatchNode, variantDataOverride).find((variant) => {
    const optionValue = variant[`option${optionPosition}`];
    return optionValue && optionValue.toLowerCase() === value.toLowerCase();
  });
}

function getVariantImageSrc(variant) {
  return variant && variant.featured_image ? variant.featured_image.src : "";
}

function getSizedVariantImageUrl(src, size) {
  if (typeof getSizedImageUrl === "function") {
    return getSizedImageUrl(src, size);
  }

  return src;
}

function getVariantImageSrcset(src) {
  if (typeof getSrcset === "function") {
    return getSrcset(src);
  }

  return src;
}

function updateProductCardHoverImage(productCard, swatchNode) {
  if (!productCard || !swatchNode) return;

  const imageWrapper = productCard.querySelector(".product-card__image-wrapper");
  const hoverImage = productCard.querySelector(".product-card__image--second img");
  if (!imageWrapper || !hoverImage) return;

  const { hoverSrc, hoverSrcset, hoverAlt } = swatchNode.dataset;
  if (!hoverSrc) {
    imageWrapper.classList.add("product-card__image-wrapper--main-only");
    return;
  }

  hoverImage.src = hoverSrc;
  hoverImage.srcset = hoverSrcset || hoverSrc;
  hoverImage.alt = hoverAlt || "";
  imageWrapper.classList.remove("product-card__image-wrapper--main-only");
}

function getVariantUrl(swatchNode, variant) {
  const existingUrl =
    swatchNode.dataset.variantUrl || swatchNode.getAttribute("href") || "";
  const baseUrl = existingUrl.split("?")[0];

  return baseUrl && variant ? `${baseUrl}?variant=${variant.id}` : existingUrl;
}

function hydrateSwatchVariantData(swatchNode, variantDataOverride) {
  const variant = getSwatchVariant(swatchNode, variantDataOverride);
  if (!variant) return null;

  const variantImage = getVariantImageSrc(variant);
  swatchNode.dataset.variantId = String(variant.id);
  swatchNode.dataset.variantAvailable = String(variant.available);
  swatchNode.dataset.variantUrl = getVariantUrl(swatchNode, variant);

  if (variantImage) {
    swatchNode.dataset.src = getSizedVariantImageUrl(variantImage, "900x");
    swatchNode.dataset.srcset = getVariantImageSrcset(variantImage);
  }

  return variant;
}

function updateProductCardFromSwatch(swatchNode) {
  if (!swatchNode) return;

  const variant = hydrateSwatchVariantData(swatchNode);
  if (!variant) return;

  const productCard = swatchNode.closest(".product-card");
  if (!productCard) return;

  const selected = swatchNode
    .closest("color-swatch")
    .querySelector('[aria-selected="true"]');
  if (selected && selected !== swatchNode) selected.removeAttribute("aria-selected");
  swatchNode.setAttribute("aria-selected", true);

  const mainImage = productCard.querySelector(".product-card__image--main img");
  const variantImage = getVariantImageSrc(variant);
  if (mainImage && variantImage) {
    mainImage.src = swatchNode.dataset.src;
    mainImage.srcset = swatchNode.dataset.srcset;
    if (variant.featured_image.alt) {
      mainImage.alt = variant.featured_image.alt;
    }
  }

  updateProductCardHoverImage(productCard, swatchNode);

  const cardTitle = productCard.querySelector(".product-card__title");
  const cardColor = productCard.querySelector(".product-card__color");
  const baseTitle =
    cardTitle?.dataset.baseTitle ||
    cardTitle?.textContent.replace(/\s+-\s+[^-]+$/, "").trim();
  if (cardColor && swatchNode.dataset.value) {
    cardColor.textContent = swatchNode.dataset.value;
  } else if (cardTitle && baseTitle && swatchNode.dataset.value) {
    cardTitle.textContent = `${baseTitle} - ${swatchNode.dataset.value}`;
  }

  const cardLink = productCard.querySelector(".full-width-link");
  if (cardLink && swatchNode.dataset.variantUrl) {
    cardLink.href = swatchNode.dataset.variantUrl;
    const label = cardLink.querySelector(".visually-hidden");
    if (label && cardTitle) label.textContent = cardTitle.textContent;
  }

  const variantInput = productCard.querySelector('input[name="id"]');
  if (variantInput) variantInput.value = String(variant.id);

  updateQuickSizesForSwatch(swatchNode);
}

function updateQuickSizesForSwatch(swatchNode) {
  const productCard = swatchNode.closest(".product-card");
  const quickSizes = productCard && productCard.querySelector(".product-card__quick-sizes");
  if (!quickSizes) return;

  const colorValue = (swatchNode.dataset.value || "").toLowerCase();
  const colorPos = parseInt(swatchNode.dataset.optionPosition, 10);
  const sizePos = parseInt(quickSizes.dataset.sizePosition, 10);
  const variants = getVariantDataForSwatch(swatchNode);

  quickSizes.querySelectorAll(".product-card__quick-size-btn").forEach((btn) => {
    const variant = variants.find((candidate) => {
      const candidateColor = candidate[`option${colorPos}`] || "";
      return (
        candidate[`option${sizePos}`] === btn.dataset.size &&
        candidateColor.toLowerCase() === colorValue
      );
    });

    if (variant) {
      btn.dataset.variantId = String(variant.id);
      btn.classList.toggle("is-unavailable", !variant.available);
    } else {
      btn.dataset.variantId = "";
      btn.classList.add("is-unavailable");
    }
  });
}

function populateQuickSizeVariant(btn) {
  if (!btn || btn.dataset.variantId) return;

  const productCard = btn.closest(".product-card");
  const swatchNode =
    productCard &&
    productCard.querySelector('color-swatch [aria-selected="true"], color-swatch [data-value]');
  if (swatchNode) updateQuickSizesForSwatch(swatchNode);
}

function getCartAddJsonUrl() {
  const route =
    window.FoxThemeSettings?.routes?.cart_add_url ||
    `${window.Shopify?.routes?.root || "/"}cart/add`;

  return route.endsWith(".js") ? route : `${route}.js`;
}

if (!customElements.get("color-swatch")) {
  class ColorSwatch extends HTMLElement {
    connectedCallback() {
      this.optionNodes = this.querySelectorAll("[data-value]");
      this.init();
    }

    disconnectedCallback() {
      this.removeEventListener("swatch-select", this._onSwatchSelect);
    }

    init() {
      const productCard = this.closest(".product-card");
      this.mainImage = productCard.querySelector(
        ".product-card__image--main img"
      );
      this.variantInput = productCard.querySelector('input[name="id"]');
      this.submitButton = productCard.querySelector('button[name="add"]');
      this.submitButtonText = productCard.querySelector(
        ".product-card__atc-text"
      );

      this.cardTitle = productCard.querySelector(".product-card__title");
      this.cardColor = productCard.querySelector(".product-card__color");
      this.cardLink = productCard.querySelector(".full-width-link");
      this.baseTitle =
        this.cardTitle?.dataset.baseTitle ||
        this.cardTitle?.textContent.replace(/\s+-\s+[^-]+$/, "").trim();

      this.optionNodes.forEach((button) =>
        button.addEventListener("click", (e) => {
          e.preventDefault();
          this.onColorChange(button);
        })
      );

      this._onSwatchSelect = (e) => this.onColorChange(e.detail.target);
      this.addEventListener("swatch-select", this._onSwatchSelect);

      this.selected = this.querySelector('a[aria-selected="true"]');

      this.quickSizes = productCard.querySelector(".product-card__quick-sizes");
      if (this.quickSizes) {
        this.sizePosition = parseInt(
          this.quickSizes.dataset.sizePosition,
          10
        );
        this.quickSizes.addEventListener("click", (e) => {
          const btn = e.target.closest(".product-card__quick-size-btn");
          if (btn) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }

      this.getVariantData();
      this.initOptionSwatches();
      const defaultSwatch = this.selected || this.optionNodes[0];
      if (defaultSwatch) {
        this.updateSelectedVariant(defaultSwatch);
        this.updateQuickSizes(defaultSwatch);
      }
    }

    onColorChange(target) {
      this.selected && this.selected.removeAttribute("aria-selected");
      target.setAttribute("aria-selected", true);

      const { src, srcset } = target.dataset;
      if (this.mainImage && srcset) {
        this.mainImage.src = src;
        this.mainImage.srcset = srcset;
      }

      updateProductCardHoverImage(
        target.closest(".product-card"),
        target
      );

      // Update split color text when present, otherwise keep legacy "Product - Color" titles.
      if (this.cardColor && target.dataset.value) {
        this.cardColor.textContent = target.dataset.value;
      } else if (this.cardTitle && this.baseTitle && target.dataset.value) {
        this.cardTitle.textContent = `${this.baseTitle} - ${target.dataset.value}`;
      }

      // Update card link so clicking the card goes to the right variant PDP
      if (this.cardLink && target.dataset.variantUrl) {
        this.cardLink.href = target.dataset.variantUrl;
      }

      this.selected = target;
      this.updateSelectedVariant(target);
      this.updateQuickSizes(target);
    }

    initOptionSwatches() {
      this.optionNodes.forEach((optNode) => {
        hydrateSwatchVariantData(optNode, this.variantData);
      });
    }

    updateSelectedVariant(target) {
      const { variantId, variantAvailable } = target.dataset;

      if (this.variantInput && variantId) {
        this.variantInput.value = String(variantId);
      }

      if (this.submitButton && this.submitButtonText && variantAvailable) {
        const isAvailable = variantAvailable === true || variantAvailable === "true";
        this.submitButton.disabled = !isAvailable;
        this.submitButtonText.textContent = isAvailable
          ? window.FoxThemeStrings.addToCart
          : window.FoxThemeStrings.soldOut;
      }
    }

    updateQuickSizes(swatchNode) {
      if (!this.quickSizes || !swatchNode) return;
      const colorValue = (swatchNode.dataset.value || "").toLowerCase();
      const colorPos = parseInt(swatchNode.dataset.optionPosition, 10);
      const colorKey = `option${colorPos}`;
      const sizeKey = `option${this.sizePosition}`;

      this.quickSizes
        .querySelectorAll(".product-card__quick-size-btn")
        .forEach((btn) => {
          const sizeValue = btn.dataset.size;
          const variant = this.variantData.find(
            (v) =>
              v[sizeKey] === sizeValue &&
              (v[colorKey] || "").toLowerCase() === colorValue
          );
          if (variant) {
            btn.dataset.variantId = String(variant.id);
            btn.classList.toggle("is-unavailable", !variant.available);
          } else {
            btn.dataset.variantId = "";
            btn.classList.add("is-unavailable");
          }
        });
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.nextElementSibling.textContent);
    }
  }
  customElements.define("color-swatch", ColorSwatch);
}

function normalizeCollectionGridCard(card) {
  if (!card || card.dataset.collectionGridNormalized === "true") return;
  if (!card.closest(".f-section-product-grid")) return;

  const wrapper = card.querySelector(".product-card__wrapper");
  const imageWrapper = card.querySelector(".product-card__image-wrapper");
  const options = card.querySelector(":scope > .product-card__options");
  const title = card.querySelector(".product-card__title");
  const selectedSwatch =
    card.querySelector('color-swatch [aria-selected="true"]') ||
    card.querySelector("color-swatch [data-value]");

  if (wrapper && imageWrapper && options) {
    options.classList.add("product-card__options--below-image");
    imageWrapper.after(options);
  }

  if (title && selectedSwatch?.dataset.value) {
    const color = selectedSwatch.dataset.value.trim();
    const titleText = title.textContent.trim();
    const baseTitle =
      title.dataset.baseTitle ||
      (titleText.endsWith(` - ${color}`)
        ? titleText.slice(0, -(` - ${color}`).length)
        : titleText.replace(/\s+-\s+[^-]+$/, "").trim());

    title.dataset.baseTitle = baseTitle;
    title.textContent = baseTitle;

    let colorNode = card.querySelector(".product-card__color");
    if (!colorNode) {
      colorNode = document.createElement("p");
      colorNode.className = "product-card__color";
      title.after(colorNode);
    }
    colorNode.textContent = color;
  }

  card.dataset.collectionGridNormalized = "true";
}

function normalizeCollectionGridCards(root = document) {
  root
    .querySelectorAll?.(".f-section-product-grid .product-card")
    .forEach(normalizeCollectionGridCard);
}

function watchCollectionGridCards() {
  const grids = document.querySelectorAll(".f-section-product-grid .product-grid");
  grids.forEach((grid) => {
    if (grid.dataset.collectionGridObserver === "true") return;
    grid.dataset.collectionGridObserver = "true";
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(".product-card")) normalizeCollectionGridCard(node);
          normalizeCollectionGridCards(node);
        });
      });
    }).observe(grid, { childList: true, subtree: true });
  });
}

function quickSizeAddToCart(btn) {
  if (
    !btn ||
    btn.classList.contains("is-unavailable") ||
    btn.classList.contains("is-adding")
  )
    return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add("is-adding");
  btn.setAttribute("aria-busy", "true");
  btn.disabled = true;

  const sectionToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:grouped-sections", {
      bubbles: true,
      detail: { sections: sectionToBundle },
    })
  );
  const cartDrawer = document.querySelector("cart-drawer");
  const mainCart = document.querySelector("cart-items");
  if (cartDrawer) {
    sectionToBundle.push(
      ...cartDrawer.getSectionsToRender().map((s) => s.id)
    );
  }
  if (mainCart) {
    sectionToBundle.push(
      ...mainCart.getSectionsToRender().map((s) => s.section)
    );
  }

  const { FoxThemeSettings, FoxThemeStrings } = window;
  const payload = {
    id: Number(variantId),
    quantity: 1,
  };

  if (sectionToBundle.length) payload.sections = sectionToBundle;
  if (mainCart || cartDrawer) payload.sections_url = window.location.pathname;

  fetch(getCartAddJsonUrl(), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(payload),
  })
    .then((r) => r.json())
    .then((response) => {
      const productCard = btn.closest(".product-card");
      if (response.status) {
        window.FoxTheme.Notification.show({
          target: productCard,
          method: "appendChild",
          type: "warning",
          message: response.description || response.message,
          last: 3000,
        });
        return;
      }

      window.FoxThemeEvents.emit("cart-update", response);

      document.dispatchEvent(
        new CustomEvent("product-ajax:added", {
          detail: { product: response },
        })
      );

      if (
        !FoxThemeSettings.cart.openDrawerWhenAdded ||
        FoxThemeSettings.cart.cartType === "page"
      ) {
        window.FoxTheme.Notification.show({
          target: productCard,
          method: "appendChild",
          type: "success",
          message: FoxThemeStrings.item_added,
          last: 3000,
        });
      }

      if (FoxThemeSettings.cart.cartType === "page") {
        FoxThemeCartHelpers.getState().then((state) => {
          FoxThemeCartHelpers.updateCartCount(state.item_count);
        });
      }
    })
    .catch(console.error)
    .finally(() => {
      btn.classList.remove("is-adding");
      btn.removeAttribute("aria-busy");
      btn.disabled = false;
    });
}

document.addEventListener("DOMContentLoaded", () => {
  normalizeCollectionGridCards();
  watchCollectionGridCards();

  document
    .querySelectorAll(".product-card.quick-sizes-enabled")
    .forEach((card) => {
      if (card.querySelector("color-swatch")) return;
      const quickSizes = card.querySelector(".product-card__quick-sizes");
      if (!quickSizes) return;
      const variantScript = card.querySelector(
        "script.product-card__variant-json"
      );
      if (!variantScript) return;
      const variantData = JSON.parse(variantScript.textContent);
      const sizePos = parseInt(quickSizes.dataset.sizePosition, 10);
      const sizeKey = `option${sizePos}`;
      quickSizes
        .querySelectorAll(".product-card__quick-size-btn")
        .forEach((btn) => {
          const sizeValue = btn.dataset.size;
          const variant = variantData.find((v) => v[sizeKey] === sizeValue);
          if (variant) {
            btn.dataset.variantId = String(variant.id);
            btn.classList.toggle("is-unavailable", !variant.available);
          } else {
            btn.classList.add("is-unavailable");
          }
        });
      quickSizes.addEventListener("click", (e) => {
        const btn = e.target.closest(".product-card__quick-size-btn");
        if (btn) quickSizeAddToCart(btn);
      });
    });
});

document.addEventListener("collection:rerendered", () => {
  normalizeCollectionGridCards();
  watchCollectionGridCards();
});
